/**
 * Token storage. Strategy: the access token lives in memory only (not readable
 * by XSS-persisted scripts across reloads); the refresh token persists so a
 * page reload can silently re-auth. If the backend later moves to httpOnly
 * cookies, this whole module becomes a no-op — nothing else changes.
 */
const REFRESH_KEY = 'fincera-refresh';

let accessToken: string | null = null;

export const tokenStore = {
  getAccess(): string | null {
    return accessToken;
  },
  setAccess(token: string | null): void {
    accessToken = token;
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  setRefresh(token: string | null): void {
    if (token) localStorage.setItem(REFRESH_KEY, token);
    else localStorage.removeItem(REFRESH_KEY);
  },
  clear(): void {
    accessToken = null;
    localStorage.removeItem(REFRESH_KEY);
  },
};
